import React from 'react';
import { Filter, NumberInput, TextInput } from 'react-admin';
import { CustomDateInput } from '../../../../commonComponents/CustomDateInput';
import UserAutocompleteInput from '../../../../commonComponents/UserAutocompleteInput';

const OrdersFilter = (props) => (
  <Filter {...props}>
    <TextInput label="User phone" source="user_phone" alwaysOn />
    <UserAutocompleteInput label="User ID" source="user_id" alwaysOn />
    <NumberInput label="Product ID" source="product_id" alwaysOn />
    <CustomDateInput label="Choose start date" source="start_date" start alwaysOn />
    <CustomDateInput label="Choose end date" source="end_date" end alwaysOn />
  </Filter>
);

export default OrdersFilter;
